import { render, staticRenderFns } from "./buildOutStock.vue?vue&type=template&id=643b94ad&scoped=true&"
import script from "./buildOutStock.vue?vue&type=script&lang=js&"
export * from "./buildOutStock.vue?vue&type=script&lang=js&"
import style0 from "./buildOutStock.vue?vue&type=style&index=0&id=643b94ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b94ad",
  null
  
)

export default component.exports